













import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {Component} from "vue-property-decorator";
import CustomerSelector from "@/shared/components/CustomerSelector/index.vue";
import LadingStatusLabel from "@/shared/components/LadingStatusLabel/index.vue";
import LadingPaymentTypeLabel from "@/modules/ladings/List/components/PaymentTypeLabel.vue";
import ManageFeeCustomerPayed from "@/modules/managefeecustomer/ListPayed/index.vue";
import ManageFeeCustomerNotYetPay from "@/modules/managefeecustomer/ListNotYetPay/index.vue";

@Component({
    name: "ManageFeeCustomer",
    components: {
        ManageFeeCustomerNotYetPay,
        ManageFeeCustomerPayed,
        LadingPaymentTypeLabel, LadingStatusLabel, CustomerSelector}
})
export default class extends mixins(CommonMixin) {
}
